import {GetCookieInfo} from "./CookieManager";
import {GetClientViewName} from "./ClientNameHelper";

const clients = [];
const currentClient = {};
const clientBundle = {};
const managerDashboard = {};

export const CacheClients = async () => {
    await GetClients();
}

export const CacheManagerDashboard = async () => {
    await fetchDashboard();
}

export const GetManagerDashboard = async (useCache = true) => {
    console.log(`GetManagerDashboard call with useCache ${useCache.toString()}`);
    if (useCache) {
        return managerDashboard;
    }
    let newDashboard = await fetchDashboard();
    return newDashboard;
}

export const CacheCurrentClient = async () => {
    await fetchCurrentClient();
}

export const CacheClientBundle = async () => {
    await fetchClientBundle();
}

export const GetCurrentClient = () => {
    return currentClient;
}
export const GetClientBundle = () => {
    return clientBundle;
}

// GetClients().then((clients) => setClients(clients));
export const GetClients = async () => {
    if (clients.length === 0) {
        await fetchClients();
        return clients;
    } else {
        return clients;
    }
}

// GetClient(clientId).then((client) => setClientDetails(client));
export const GetClient = async (id, useCache = true) => {
    if (useCache) {
        if (clients.length === 0) {
            await fetchClients();
            return clients.find(e => e.id === Number(id));
        } else {
            return clients.find(e => e.id === Number(id));
        }
    } else {
        let client = await fetchClient(id);
        return client;
    }
}

export const UpsertClientCache = (client) => {
    if (!clients.find(e => e.id === client.id)) {
        clients.push(client);
    }
}

const fetchClients = async () => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(process.env.REACT_APP_CONTACTS_URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + tokenCookie.value,
            },
        });
        if (response.ok) {
            const data = await response.json();
            console.log(data.data);

            clients.length = 0;
            if (data.data) {
                data.data.sort((a, b) => {
                    return GetClientViewName(b).localeCompare(GetClientViewName(a));
                });
                data.data.forEach(e => clients.push(e));
            }
        } else {
            console.log('Fetch clients failed.');
        }
    } catch (error) {
        console.log('An error occurred:', error);
    }
};
export const fetchClient = async (id) => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_CONTACTS_URL}/${id}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
            }
        );
        if (response.ok) {
            const data = await response.json();
            let cachedClientIndex = clients.indexOf(clients.find(e => e.id === Number(id)));
            if (cachedClientIndex === -1) {
                clients.push(data.data);
            } else {
                clients[cachedClientIndex] = data.data;
            }
            return data.data;
        } else {
            console.log('Fetch client failed.');
            return null;
        }
    } catch (error) {
        console.log('An error occurred:', error);
        return null;
    }
};

const fetchCurrentClient = async () => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_CONTACTS_URL}/current`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
            }
        );
        if (response.ok) {
            const data = await response.json();

            Object.keys(currentClient).forEach(key => delete currentClient[key]);
            Object.keys(data.data).forEach(key => currentClient[key] = data.data[key]);

            console.log('Current client fetched.');
            console.log(currentClient);

            return data.data;
        } else {
            console.log('Fetch client failed.');
            return null;
        }
    } catch (error) {
        console.log('An error occurred:', error);
        return null;
    }
};

const fetchClientBundle = async () => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_BUNDLE_URL}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
            }
        );
        if (response.ok) {
            const data = await response.json();

            Object.keys(clientBundle).forEach(key => delete clientBundle[key]);
            Object.keys(data.data).forEach(key => clientBundle[key] = data.data[key]);

            if (clientBundle.tickets && clientBundle.tickets.length > 0){
                clientBundle.tickets.sort((a, b) => {
                    const dateA = new Date(a.openDate);
                    const dateB = new Date(b.openDate);
                    return dateB - dateA;
                });
            }

            Object.keys(currentClient).forEach(key => delete currentClient[key]);
            if (data.data.contact) {
                Object.keys(data.data.contact).forEach(key => currentClient[key] = data.data.contact[key]);
            }

            console.log('Client bundle fetched.');
            console.log(clientBundle);

            return data.data;
        } else {
            console.log('Fetch bundle failed.');
            return null;
        }
    } catch (error) {
        console.log('An error occurred:', error);
        return null;
    }
};

const fetchDashboard = async () => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_DASHBOARD_URL}/manager`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
            }
        );
        if (response.ok) {
            const data = await response.json();
            console.log(data.data);

            data.data.activeOrders?.sort((a, b) => {
                const dateA = new Date(a.createdDate);
                const dateB = new Date(b.createdDate);
                return dateA - dateB;
            });
            data.data.lastTrades?.sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);
                return dateB - dateA;
            });

            data.data.notifications?.sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);
                return dateB - dateA;
            });

            data.data.notifications?.forEach((elem) => {
                elem.metaObj = JSON.parse(elem.meta);
            });

            Object.keys(managerDashboard).forEach(key => delete managerDashboard[key]);
            Object.keys(data.data).forEach(key => managerDashboard[key] = data.data[key]);

            return data.data;
        } else {
            console.log('Fetch dashboard failed.');
            return null;
        }
    } catch (error) {
        console.log('An error occurred:', error);
        return null;
    }
};